import React, { useContext, useEffect, useSyncExternalStore } from "react"
import { ClickAwayListener, DialogActions, DialogContent } from "@mui/material"
import { useMobile } from "lib/@components/mobile"
import { OkCancelContext } from "lib/@hooks/useDialog"
import { If } from "lib/@components/switch"

export function RightDrawerDialog({ state, setOpen }) {
    const isMobile = useMobile()
    const okCancel = useContext(OkCancelContext)
    const { ok } = okCancel
    useSyncExternalStore(state.subscribe, state.getSnapshot, state.getSnapshot)

    const { children, dialogActions, onClose } = state.content
    const dialogActionsWithProps = getDialogActionsWithProps()

    useEffect(closeDialogWhenDesktop, [isMobile, ok])

    return (
        <>
            {/* ClickAwayListener counts clicks in menus, poppers and nested dialogs the content
                renders in portals (an Autocomplete's options, a Select's menu) as inside: they
                are inside in React terms, although their DOM is not. Taps use its default
                touch handling, so tapping outside closes on touch devices but a scroll does not */}
            <ClickAwayListener onClickAway={handleClickAway} mouseEvent="onMouseDown">
                <DialogContent>{children}</DialogContent>
            </ClickAwayListener>
            <If value={dialogActionsWithProps}>
                <DialogActions sx={{ display: "unset" }}>{dialogActionsWithProps}</DialogActions>
            </If>
        </>
    )

    function closeDialogWhenDesktop() {
        if (!isMobile) {
            ok()
        }
    }

    function handleClickAway() {
        onClose?.()
    }

    function getDialogActionsWithProps() {
        if (!dialogActions) return null
        return React.cloneElement(dialogActions, { isMobile, ok, setOpen })
    }
}
